// Which menu items a user sees (plans/REDESIGN.md, phase 2): the same role-permission
// and plan-feature rules the sidebar always used. Pure, so it can be tested.

// The user's combined role permissions, as admin-routes hasPermission() reads them.
function combinePermissions(roles = []) {
  return roles.reduce((acc, role) => {
    Object.entries(role).forEach(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        acc[key] = acc[key] || {}
        Object.entries(value).forEach(([permKey, permValue]) => {
          acc[key][permKey] = acc[key][permKey] || permValue
        })
      }
    })
    return acc
  }, {})
}

const allows = (section) => !!(section && (section.read || section.access || section.create || section.update || section.delete))

// Visible items, each with the path of its first allowed section.
export function visibleItems(items, { roles, features }) {
  const permissions = roles?.length ? combinePermissions(roles) : null
  return items
    .map((item) => {
      if (!item.keys) return item
      const allowed = item.keys.filter(
        (key) => (!permissions || allows(permissions[key])) && (item.plan === false || !features?.length || features.find((f) => f.includes(key)))
      )
      if (!allowed.length) return null
      return { ...item, path: item.paths?.[allowed[0]] || item.path }
    })
    .filter(Boolean)
}
